import { render, staticRenderFns } from "./orderFormItemsView.vue?vue&type=template&id=d638ab04&scoped=true&"
import script from "./orderFormItemsView.vue?vue&type=script&lang=js&"
export * from "./orderFormItemsView.vue?vue&type=script&lang=js&"
import style0 from "./orderFormItemsView.vue?vue&type=style&index=0&id=d638ab04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d638ab04",
  null
  
)

export default component.exports